<template>
  <v-container fluid>
    <back-link-component :to="{ name: 'RefLineListAsList' }" :label="$tt('customRefLine')" />
    <h2>{{ $tt('customRefLineUploadTitle') }}</h2>
    <geo-file-import :importMode="importMode" />
  </v-container>
</template>

<script>
import GeoFileImport from '@/components/import/GeoFileImport'
import * as Constants from '@/lib/constants'
import RefLineMixin from '@/components/mixins/ref-line-mixin'

export default {
  name: 'RefLineImport',
  mixins: [RefLineMixin],
  components: {
    GeoFileImport,
  },
  data() {
    return {
      importMode: Constants.IMPORT_MODE.REFLINES,
    }
  },
  mounted() {
    this.checkAvailabilityBeforeMount()
  },
}
</script>
